import {getUpdatedMenuCache} from 'helpers/menu.helper';
import {MENU_SUCCESS} from 'new-constants/api.constants';
import {MenuState} from './menu.reducer.types';

const initialState: MenuState = {
	cache: [],
};

export const menuReducer = (previousState = initialState, action) => {
	switch (action && action.type) {
		case MENU_SUCCESS:
			return {
				...previousState,
				cache: getUpdatedMenuCache(previousState.cache, action.payload.data, action.payload.currentCustomer),
			};
			break;
		default:
			return previousState;
	}
};
